<template>
  <el-input-number
    v-model="initNumberValue"
    v-bind="{
      ...item,
      precision: item.precision ? Number(item.precision) : undefined
    }"
    @change="handleChange"
  />
</template>

<script>
import mixin from '../mixin'

export default {
  name: 'TNumber',
  mixins: [mixin],
  data() {
    return {
      oldValue: null,
      initNumberValue: this.value === '' || this.value === null ? undefined : this.value
    }
  },
  methods: {
    handleChange(val) {
      this.changeValue = val
    }
  }
}
</script>

<style scoped></style>
